import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';

import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';

import * as actions from '../../../store/modules/auth/actions';

import { displayErrors } from '../../../util/diversos';
import { Input100px } from '../../../styles/inputGroup';

import Card from '../../../components/card';
import Loading from '../../loading';
import axiosAdmin from '../../../services/axiosAdmin';

export default function CadastroIcmsModalidadeBcSt() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const id = get(useParams(), 'id', 0);

  const [codigo, setCodigo] = useState(0);
  const [descricao, setDescricao] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let newTitle = 'Modalidade de Cálculo da BC do ICMS ST - Cadastro';
    if (id) {
      newTitle = 'Modalidade de Cálculo da BC do ICMS ST - Edição';
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    if (!id) return;

    async function getData() {
      try {
        setIsLoading(true);

        const { data } = await axiosAdmin.get(`/icmsmodalidadebcst/${id}`);

        setCodigo(data.codigo);
        setDescricao(data.descricao);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [dispatch, id, navigate]);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const shippingData = {
        codigo,
        descricao,
      };

      if (id > 0) {
        await axiosAdmin.put(`/icmsmodalidadebcst/${id}`, shippingData);
        toast.success('Modalidade de Cálculo da BC do ICMS ST atualizado com sucesso');
      } else {
        await axiosAdmin.post('/icmsmodalidadebcst', shippingData);
        toast.success('Modalidade de Cálculo da BC do ICMS ST cadastrada com sucesso');
      }

      navigate('/consultaicmsmodalidadebcst');
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível atualizar o registro');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    navigate('/consultaicmsmodalidadebcst');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (codigo < 0 || codigo > 9999) {
      formErros = true;
      toast.error('Código inválido');
    }
    if (descricao.length < 3 || descricao.length > 255) {
      formErros = true;
      toast.error('Descrição deve ter entre 3 a 255 caracteres');
    }

    if (formErros) return;

    salvarRegistro();
  };

  const titulo = () => (id ? 'Modalidade de Cálculo da BC do ICMS ST - Alteração' : 'Modalidade de Cálculo da BC do ICMS ST - Inclusão');

  return (
    <div>
      <Loading isLoading={isLoading} />
      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}>{titulo()}</h6>
        </div>
        <div className="row form-elo">
          <div className="col-3">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Código
              </Input100px>
              <InputNumber
                min={0}
                max={9999}
                value={codigo}
                onValueChange={e => setCodigo(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-9">
            <div className="p-inputgroup">
              <Input100px className="p-inputgroup-addon">
                Descrição
              </Input100px>
              <InputText
                maxLength={255}
                value={descricao}
                onChange={e => setDescricao(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-success"
            >
              <i className="pi pi-check"></i>
              Salvar
            </button>
            <button
              onClick={handleCancel}
              type="button"
              className="btn btn-danger"
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}
